import { MovementData } from './dataLayers/movementData';
import { CollectionData } from './dataLayers/collectionData';
import { dataType } from './dataType';
import { TeleportData } from './dataLayers/teleportData';

export class Map {
    constructor(mapData, width, height, tileWidth, tileHeight) {
        this.data = mapData;

        this.id = mapData.id;
        this.width = width;
        this.height = height;
        this.tileWidth = tileWidth;
        this.tileHeight = tileHeight;
        this.tilesWide = this.width / this.tileWidth;
        this.tilesHigh = this.height / this.tileHeight;

        this.tilesets = [];
        this.visualTopLayers = [];
        this.visualBottomLayers = [];

        this.dataLayers = {};
        this.movementData = new MovementData();
        this.collectionData = new CollectionData();
        this.teleportData = new TeleportData();
    }

    addTileset(tileset) {
        this.tilesets.push(tileset);
    }

    addVisualTopLayer(layer) {
        this.visualTopLayers.push(layer);
    }

    addVisualBottomLayer(layer) {
        this.visualBottomLayers.push(layer);
    }

    addDataLayer(layer) {
        switch (layer.dataType) {
            case dataType.movement:
                this.movementData.addLayer(layer);
                break;
            case dataType.teleport:
                this.teleportData.addLayer(layer);
                break;
            case dataType.collect:
                this.collectionData.addLayer(layer);
                break;
            default:
                this.dataLayers[layer.id] = layer;
                break;
        }
    }

    getTileData(index, layers) {

    }
}
